import React from 'react';
import s from './style.css';
const ActionButton = ({ text, icon, onClick, style, htmlFor }) => {
    return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    React.createElement("label", { htmlFor: htmlFor, className: s.container, style: style, onClick: onClick, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                onClick?.(e);
            }
        } },
        icon && React.createElement("div", { style: { marginRight: 6 } }, icon),
        React.createElement("p", { className: s.text }, text)));
};
export default ActionButton;
